$(document).ready(function() {

    var stickyOffset = $('.header__hero').outerHeight();

    var stickyNav = function () {
        var fromTop = $(window).scrollTop();
        if (fromTop > stickyOffset) {
            $("body").addClass('sticky--nav');
            console.log('sn');
        } else {
            $("body").removeClass('sticky--nav');
        }        
    }

    $(window).scroll(function(){
        stickyNav();
    });

    $(window).resize(function(){
        var stickyOffset = $('.header__hero').outerHeight();
    });

    if($(window).width() < 768 ) $(".video--brand").attr("controls",true);

    $('.hero__text').delay(400).fadeIn(400, function(){
      $('.hero__bkgd').fadeIn(800);
    });

    $('.header__text--animate').delay(400).fadeIn(400, function(){
        $(this).css("opacity","1");
    });

    $('.nav__trigger').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        
        $('body').toggleClass('nav--open');
    });

    $('.readmore--trigger').on('click', function(e){
        e.preventDefault();
        $('.readmore--hide').removeClass('readmore--hide');
        $(this).attr('class', 'readmore--hide');
    });

    var _ParallaxHover = function(el) {
        // Set up handle
        var t = this,
            $orig = $(el);
        // Extend object with handy variables
        t.$link = $orig;
        t.levels = parseInt(t.$link.data('levels'));
        t.space = parseInt(t.$link.data('space'));
        t.imgName = t.$link.data('imgname');
        t.images = new Array();
        t.pos = $orig.offset();
        t.dim = {
            w: $orig.outerWidth(),
            h: $orig.outerHeight()
        };
        t.$levels = $();
        t.threshold = 1;
        t.cPos = {
            x: t.dim.w / 2,
            y: t.dim.h / 2
        };
        t.tPos = {
            x: t.cPos.x,
            y: t.cPos.y
        };
        t.vPos = {
            x: 0,
            y: 0
        };
        t.interval;
        t.isLooping = false;

        $('.header-container').mousemove(function(e) {
            var mPos = {
                x: e.pageX,
                y: e.pageY
            },
                xPos = mPos.x - t.pos.left,
                yPos = mPos.y - t.pos.top;
            t.tPos = {
                x: xPos,
                y: yPos
            };
            t.startAnimationLoop();
        }).mouseenter(function() {
            t.startAnimationLoop();
        }).mouseleave(function() {
            t.tPos.x = t.dim.w / 2;
            t.tPos.y = t.dim.h / 2;
        });
        // Return object
        return this;
    };
    _ParallaxHover.prototype.animateTo = function(x, y) {
        var t = this;
        t.tPos = {
            x: x,
            y: y
        };
        t.startAnimationLoop();
    };
	_ParallaxHover.prototype.startAnimationLoop = function() {
		var t = this;
		if (!t.isLooping) {
			t.isLooping = true;
			t.interval = setInterval(function() {
				t.animationLoop();
			}, 35);
		}
	};
    _ParallaxHover.prototype.setPosition = function() {
        var t = this;
        $('.hero__molecule').each(function(i) {
            var $level = $(this);
            var index = i + 1,
                mid = Math.round(t.levels / 2),
                dist = (index - mid) / (t.levels - mid);
            $level.data('dist', dist);
            $level.css({
                'top': ((t.cPos.y / t.dim.h) * 2 - 1) * t.space * $level.data('dist'),
                'left': ((t.cPos.x / t.dim.w) * 2 - 1) * t.space * $level.data('dist')
            });
        });
        return t.cPos;
    };
    _ParallaxHover.prototype.animationLoop = function() {
		var t = this,
			x = (t.tPos.x - t.cPos.x),
			y = (t.tPos.y - t.cPos.y);
		t.vPos.x *= 0.7;
		t.vPos.y *= 0.7;
		x *= 0.10;
		y *= 0.10;
		t.vPos.x += x;
		t.vPos.y += y;
		t.cPos.x += t.vPos.x;
		t.cPos.y += t.vPos.y;
		if (t.vPos.x >= t.threshold || t.vPos.y >= t.threshold || t.vPos.x <= -t.threshold || t.vPos.y <= -t.threshold) {
			t.setPosition();
		} else {
			t.isLooping = false;
			clearInterval(t.interval);
		}
	};
    $('.header__hero').each(function() {
		window.parallaxHover = new _ParallaxHover(this);
	});

    var os = avast.getOS();
    var $cta = $('.get-avast');
    var $ctam = $('.get-mobile');

    var locale = avast.locale;
    var domain = 'https://www.avast.com/' + locale + '/';

    if (locale === 'ru-ru') {
        var domain = 'https://www.avast.ru/';    
    }

    switch (os) {
        case 'Windows':
            $cta.attr('href', domain + 'windows');
            break;
        case 'IOS':
            $cta.attr('href', domain + 'ios');
            $ctam.attr('href', 'https://itunes.apple.com/app/apple-store/id793096595?mt=8');
            break;
        case 'Android':
            $cta.attr('href', domain + 'android');
            break;
        case 'Mac':
            $cta.attr('href', domain + 'mac');
            $ctam.attr('href', 'https://itunes.apple.com/app/apple-store/id793096595?mt=8');
            break;
    }
});
